
import Component from 'vue-class-component'
import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import config from '@/utils/config'

@Component({})
export default class Logo extends Vue {
    @Prop()
    logoClass: string
    @Prop({ default: false })
    showTextWhite: boolean
    @Prop({ default: false })
    showTextBlue: boolean
    @Prop()
    textClass: string

    config = config

    getLogoImages() {
        if (config.companyName === 'CNA') {
            return {
                logo: config.logo,
                logoWhite: config.logoWhite,
                logoBlue: config.logoBlue,
            }
        } else {
            return { logo: config.logo }
        }
    }
}
